var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22.3666,
    height: 25.8093,
    transform: "translate(8 0.529785) rotate(15.8651)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2717_4667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6982 5.98999L12.1237 7.74674L13.0021 8.03402L8.98009 20.3313C8.67532 21.2631 8.75321 22.2779 9.19661 23.1523C9.64002 24.0267 10.4126 24.6891 11.3445 24.9939C12.2763 25.2987 13.291 25.2208 14.1655 24.7774C15.0399 24.334 15.7023 23.5614 16.0071 22.6295L20.0291 10.3323L20.9074 10.6196L21.482 8.86282L12.6982 5.98999ZM12.1898 19.4364C11.6628 19.264 11.4263 18.7977 11.5987 18.2707C11.7711 17.7437 12.2373 17.5073 12.7643 17.6796C13.2914 17.852 13.5278 18.3183 13.3554 18.8453C13.1831 19.3723 12.7168 19.6087 12.1898 19.4364ZM15.0957 16.4974C14.5686 16.3251 14.3322 15.8588 14.5046 15.3318C14.6769 14.8048 15.1432 14.5683 15.6702 14.7407C16.1973 14.9131 16.4337 15.3793 16.2613 15.9063C16.089 16.4334 15.6227 16.6698 15.0957 16.4974ZM17.4105 12.3928L13.897 11.2437L14.7588 8.60859L18.2723 9.75772L17.4105 12.3928Z",
    fill: "#999CA2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2717_4667)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0137 14.9956L17.0263 15.9994L17.5192 15.9932L17.6076 23.0196C17.6143 23.552 17.8284 24.0601 18.2029 24.4319C18.5774 24.8037 19.0816 25.0089 19.6045 25.0024C20.1274 24.9958 20.6263 24.778 20.9913 24.3968C21.3564 24.0157 21.5577 23.5025 21.551 22.97L21.4626 15.9436L21.9555 15.9374L21.9429 14.9336L17.0137 14.9956ZM19.0737 21.9972C18.778 22.001 18.5783 21.8027 18.5745 21.5015C18.5707 21.2004 18.7653 20.9972 19.0611 20.9935C19.3569 20.9897 19.5565 21.188 19.5603 21.4892C19.5641 21.7903 19.3695 21.9935 19.0737 21.9972ZM20.0343 19.9773C19.7386 19.981 19.5389 19.7827 19.5351 19.4816C19.5313 19.1805 19.726 18.9772 20.0217 18.9735C20.3175 18.9698 20.5172 19.1681 20.5209 19.4692C20.5247 19.7703 20.3301 19.9736 20.0343 19.9773ZM20.4957 17.4617L18.524 17.4864L18.5051 15.9808L20.4768 15.956L20.4957 17.4617Z",
    fill: "#BFC4CA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2717_4667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.24162,
    height: 18.4832,
    fill: "white",
    transform: "translate(12.6982 5.98999) rotate(18.1109)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2717_4667"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.27409,
    height: 10.0385,
    fill: "white",
    transform: "translate(16.3418 15.0042) rotate(-0.720379)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestIcon);
export default __webpack_public_path__ + "static/media/test_icon.0633e5dc16bc4f726ed5c67fcf11dae1.svg";
export { ForwardRef as ReactComponent };